import { UIBreakPointConfig, UIComponentConfig } from 'config/layout'
import Menu from 'layout/Components/Menu'
import React from 'react'
import { Trans } from 'react-i18next'
import { useMenuContainer } from 'state/app/hooks'
import { useAuth } from 'state/auth/hooks'
import { useUnwatchedNewBonusListener } from 'state/bonus/hooks'
import styled, { css } from 'styled-components'
import { Icons } from 'svgs'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'

const NotificationBadge = () => {
  const { isMenuOpen } = useMenuContainer()
  const [unwatchedNewBonus, onClose] = useUnwatchedNewBonusListener()
  const { isSigned } = useAuth()

  return (
    unwatchedNewBonus &&
    isSigned && (
      <StyledNotificationContainer $smallMenu={!isMenuOpen}>
        <Text color="#161C24" fontSize="12px" fontWeight={500}>
          <Trans>You have received a new reward, check it out now!</Trans>
        </Text>

        <StyledCloseIcon
          width="12px"
          height="12px"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onClose()
          }}
        >
          <Icons.ClearIcon width="12px" height="12px" />
        </StyledCloseIcon>
      </StyledNotificationContainer>
    )
  )
}

const MainMenu: React.FC<{ config?: UIBreakPointConfig<UIComponentConfig> }> = ({ config }) => {
  return (
    <>
      <NotificationBadge />
      <Menu layoutConfig={config} />
    </>
  )
}

const StyledNotificationContainer = styled(Flex)<{ $smallMenu: boolean }>`
  background: ${({ theme }) => theme.colors.textTertiary} !important;
  border-radius: ${({ theme }) => theme.radii.tiny};
  gap: 8px;
  padding: 4px 8px;
  z-index: 6;
  position: absolute;
  top: 90px;
  left: 230px;
  transition: 0.2s all;
  line-height: 20px;
  align-items: center;

  ${({ $smallMenu }) =>
    $smallMenu &&
    css`
      left: 65px;
    `};

  &:before {
    content: '';
    position: absolute;
    top: 6.5px;
    left: -4px;
    width: 10px;
    height: 10px;
    transform: rotate(135deg);
    border-radius: 1px;
    background: ${({ theme }) => theme.colors.textTertiary} !important;
    backdrop-filter: blur(6px);
    z-index: -2;
  }

  display: none;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
  }
`

const StyledCloseIcon = styled(Flex)`
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #6c727e;
    fill: #6c727e;
  }
`

export default MainMenu
